<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <div class="well well-sm">

            <!-- Channel Name -->
              <div class="form-group">
                <div class="col-md-3 control-label" for="name">Channel Name</div>
                <div class="col-md-9">
                  <select class="form-select" aria-label="Default select example" v-model="Notification.receiver_id">
                  <option v-for="(person, index) in allusers" :key="index" :value="person.id">{{person.name}} - {{person.email}}</option>
                </select>
                </div>
              </div>

              <!-- Message -->
              <div class="form-group">
                <div class="col-md-3 control-label" for="email">Message</div>
                <div class="col-md-9">
                  <input
                    id="message"
                    name="message"
                    type="text"
                    class="form-control"
                     maxlength="60"
                    v-model="Notification.message"
                  />
                </div>
              </div>

              <!-- Url -->
              <div class="form-group">
                <div class="col-md-3 control-label" for="url">Url</div>
                <div class="col-md-9">
                  <input
                    id="url"
                    name="url"
                    type="text"
                    class="form-control"
                     maxlength="1024"
                    v-model="Notification.url"
                  />
                </div>
              </div>

              <!-- Form actions -->
              <div class="form-group">
                <div class="col-md-9 text-right">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg"
                    @click="SendNotification">
                    Send Notification
                  </button>
                </div>
              </div>

        </div>
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  props: ['user'],

  data() {
    return {
      allusers: [],
      Notification: { user_id: this.user.id, 
                sent_by: this.user.name,
                created_at: new Date(),
                message: 'Application has been approved', 
                url: '/notifications' },
      
    };
  },

mounted() {},

created() { 

    this.getUsers();

},

methods: {
  SendNotification() {
    axios
      .post('/notifications/broadcast', this.Notification)
      .then((response) => {
        this.showToaster("Notification has been sent")

      });
  },

showToaster(text) {
      this.$toaster.success(text, { timeout: 2000 });
    },

  getUsers() {
    axios
      .get('/notifications/allusers')
      .then((response) => {
        this.allusers = response.data;
        //console.log(response.data);
        //console.log(this.Config);

      })
      .catch(function (error) {
        console.log(error);
      });
  },
}

};
</script> 

<style scoped>
.popup {
  background-color: #283046 !important;
}
.title {
  font-weight: normal;
  font-size: 16px;
}
select.form-select {width: 100%;padding: 8px 10px;font-size: 1.1rem;}
select.form-select:hover {cursor: pointer;}
</style>
